import api_fabric from "../../api/ApiFabric";
import store from "../../store/index.js";
import BillingService from "@libs/billing/wf/BillingService";

const api_billing = function() {
  return api_fabric.getInstance("Billing", true);
};
const api_billing_site = function() {
  return api_fabric.getInstance("BillingSite", true);
};
export default function billingServiceInit() {
  BillingService.setSettings({
    store,
    api_billing,
    api_billing_site,
  });
}
